<p-table [value]="expenseList" 
  autoLayout=true 
  [paginator]="true" 
  [loading]="loading" 
  [rows]="10" 
  [rowsPerPageOptions]="[10,25,50,100]" 
  (onLazyLoad)="expenseSearch($event)"
  [totalRecords]="totalRecords"
  paginatorPosition="both"
  [loading]="loading"
  [lazyLoadOnInit] = "false"
  [resetPageOnSort] = "false"
  [lazy]="true">
    
    <ng-template pTemplate="header">
      <tr>
        <th [pSortableColumn]="'Lender'">Lender <p-sortIcon [field]="'Lender.PublicName'"></p-sortIcon></th>
        <th [pSortableColumn]="'ReoNumber'">REO <p-sortIcon [field]="'ReoNumber'"></p-sortIcon></th>
        <th [pSortableColumn]="'LoanNumber'">Loan Number <p-sortIcon [field]="'LoanNumber'"></p-sortIcon></th>
        <th [pSortableColumn]="'Address'">Address <p-sortIcon [field]="'Address.Address1'"></p-sortIcon></th>
        <th [pSortableColumn]="'City'">City <p-sortIcon [field]="'Address.City'"></p-sortIcon></th>
        <th [pSortableColumn]="'State'">State <p-sortIcon [field]="'Address.State'"></p-sortIcon></th>
        <th [pSortableColumn]="'Zip'">Zip <p-sortIcon [field]="'Address.PostalCode'"></p-sortIcon></th>
        <th [pSortableColumn]="'Status'">Expense Status <p-sortIcon [field]="'Status'"></p-sortIcon></th>
        <th [pSortableColumn]="'PreFCL'">Pre-Foreclosure <p-sortIcon [field]="'PreFCL'"></p-sortIcon></th>
        <th [pSortableColumn]="'PayeeID'">Payee ID <p-sortIcon [field]="'PayeeID'"></p-sortIcon></th>
        <th [pSortableColumn]="'InvoiceNumber'">Invoice Number <p-sortIcon [field]="'InvoiceNumber'"></p-sortIcon></th>
        <th [pSortableColumn]="'TransactionID'">Trans ID <p-sortIcon [field]="'TransactionID'"></p-sortIcon></th>
        <th [pSortableColumn]="'CheckNumber'">Check Number <p-sortIcon [field]="'CheckNumber'"></p-sortIcon></th>
        <th [pSortableColumn]="'Amount'">Amount <p-sortIcon [field]="'Amount'"></p-sortIcon></th>
        <th [pSortableColumn]="'ExpenseCode'">Exp Code <p-sortIcon [field]="'ExpenseCode'"></p-sortIcon></th>
        <th [pSortableColumn]="'CreateDate'">Create Date <p-sortIcon [field]="'CreateDate'"></p-sortIcon></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-expense>
      <tr>
          
          <td>{{expense.Lender.PublicName}}</td>
          <td><a class="iconNewWindow" target="_blank" href="{{propertyUrl(expense.PropertyId)}}">{{expense.ReoNumber}}</a></td>
          <td>{{expense.LoanNumber}}</td>
          <td>{{expense.Address.Address1}}</td>
          <td>{{expense.Address.City}}</td>
          <td>{{expense.Address.State}}</td>
          <td>{{expense.Address.PostalCode}}</td>
          <td>{{expense.Status}}</td>
          <td>{{expense.PreFCL ? 'Yes' : 'No'}}</td>
          <td>{{expense.PayeeID}}</td>
          <td>{{expense.Invoice.InvoiceId}}</td>
          <td>{{expense.TransactionID}}</td>
          <td>{{expense.Invoice.CheckNumber}}</td>
          <td>{{expense.Invoice.Amount}}</td>
          <td>{{expense.ExpenseCode}}</td>
          <td>{{expense.CreateDate}}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="paginatorright">
        <span *ngIf="!loading">
            <a href="{{buildExcelUrl()}}" class="excelLink iconExcel iconExcelAlign">Excel Export</a> Showing {{this.searchParams.Offset}} to {{this.searchParams.EndRow}} of {{totalRecords}} Records 
        </span>
    </ng-template>
  </p-table>